import * as React from 'react';
import ReactReCaptcha, { RecaptchaProps } from 'react-recaptcha';

export interface Props extends RecaptchaProps {
    reCaptchaKey: string;
    onVerification: (token: string) => void;
}

const ReCaptcha: React.FC<Props> = ({ reCaptchaKey, onVerification, ...props }) => (
    <ReactReCaptcha sitekey={reCaptchaKey} verifyCallback={onVerification} {...props} />
);

export default ReCaptcha;
